import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import get from "lodash/get";
import { useTheme } from "@mui/material/styles";
import icons from "./icons.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function Icon_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else Icon_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const Icon = (t0)=>{
    const $ = c(18);
    let color;
    let name;
    let props;
    let size;
    if ($[0] !== t0) {
        ({ name, size, color } = t0), props = _object_without_properties(t0, [
            "name",
            "size",
            "color"
        ]);
        $[0] = t0;
        $[1] = color;
        $[2] = name;
        $[3] = props;
        $[4] = size;
    } else {
        color = $[1];
        name = $[2];
        props = $[3];
        size = $[4];
    }
    const theme = useTheme();
    let t1;
    if ($[5] !== color || $[6] !== theme.tokens.colors) {
        t1 = color ? get(theme.tokens.colors, color) : void 0;
        $[5] = color;
        $[6] = theme.tokens.colors;
        $[7] = t1;
    } else t1 = $[7];
    const colorCode = t1;
    const sizeInPixels = theme.tokens.iconSizes[size];
    const iconVariants = icons[name];
    const ExactIcon = iconVariants[sizeInPixels];
    if (ExactIcon) {
        let t2;
        if ($[8] !== ExactIcon || $[9] !== colorCode || $[10] !== props || $[11] !== sizeInPixels) {
            t2 = /*#__PURE__*/ jsx(ExactIcon, _object_spread_props(_object_spread({}, props), {
                width: sizeInPixels,
                height: sizeInPixels,
                color: colorCode
            }));
            $[8] = ExactIcon;
            $[9] = colorCode;
            $[10] = props;
            $[11] = sizeInPixels;
            $[12] = t2;
        } else t2 = $[12];
        return t2;
    }
    const sizes = Object.keys(iconVariants).map(Number);
    const closestSize = sizes.reduce((prev, curr)=>Math.abs(curr - sizeInPixels) < Math.abs(prev - sizeInPixels) ? curr : prev);
    const ClosestIcon = iconVariants[closestSize];
    let t2;
    if ($[13] !== ClosestIcon || $[14] !== colorCode || $[15] !== props || $[16] !== sizeInPixels) {
        t2 = /*#__PURE__*/ jsx(ClosestIcon, _object_spread_props(_object_spread({}, props), {
            width: sizeInPixels,
            height: sizeInPixels,
            color: colorCode
        }));
        $[13] = ClosestIcon;
        $[14] = colorCode;
        $[15] = props;
        $[16] = sizeInPixels;
        $[17] = t2;
    } else t2 = $[17];
    return t2;
};
export { Icon };
